import { SUBSCRIPTION_FLAG } from '@/utils/constants';
import { useMemo } from 'react';
import { useSSRSelector } from 'src/redux';

export function useFeatureLocks() {
  const { featureLocks, storeData } = useSSRSelector((state: any) => ({
    featureLocks: state.commonReducer.featureLocksData.featureLocks,
    storeData: state.storeReducer.store,
  }));

  const isEcommExpired = useMemo(
    () => storeData?.subscription_flag === SUBSCRIPTION_FLAG.EXPIRED,
    [storeData?.subscription_flag]
  );

  const crrFeatureStatus = featureLocks['crr'];
  const couponsFeatureStatus = featureLocks['couponsVouchers'];
  const fbPixelFeatureStatus = featureLocks['fbPixel'];
  const googleAnalyticsFeatureStatus = featureLocks['googleAnalytics'];
  const googleTagFeatureStatus = featureLocks['gtm'];
  const installAppFeatureStatus = featureLocks['installApp'];
  const leadGenFeatureStatus = featureLocks['leadGen'];
  const visitorLoginFeatureStatus = featureLocks['visitorLogin'];
  const collectionsFeatureStatus = featureLocks['collections'];
  const notifyMeFeatureStatus = featureLocks['notifyMe'];
  const partialPaymentFeatureStatus = featureLocks['partialPayment'];
  const memberOnlyLoginFeatureStatus = featureLocks['memberOnlyLogin'];
  const wishlistFeatureStatus = featureLocks['wishlist'];

  return {
    collectionsFeatureStatus,
    couponsFeatureStatus,
    crrFeatureStatus,
    fbPixelFeatureStatus,
    googleAnalyticsFeatureStatus,
    googleTagFeatureStatus,
    installAppFeatureStatus,
    leadGenFeatureStatus,
    visitorLoginFeatureStatus,
    isEcommExpired,
    notifyMeFeatureStatus,
    partialPaymentFeatureStatus,
    memberOnlyLoginFeatureStatus,
    wishlistFeatureStatus,
  };
}
